  export const selectStyles = {
    control: (baseStyles) => ({
      ...baseStyles,
      borderRadius: '10px',
      width: '100%',
    }),
    indicatorSeparator: (baseStyles) => ({
      ...baseStyles,
      display: 'none',
    }),
    option: (baseStyles) => ({
      ...baseStyles,
      fontWeight: 'light',
    }),
    placeholder: (baseStyles) => ({
      ...baseStyles,
      fontWeight: '300',
      fontSize: '14px',
    }),
    menu: (baseStyles) => ({
      ...baseStyles,
      zIndex: 9999,
    }),
    menuList: (baseStyles) => ({
      ...baseStyles,
      zIndex: 9999,
    }),
  };
  
  export const multiSelectStyles = {
    control: (base, state) => ({
      ...base,
      borderRadius: '10px',
      boxShadow: 'none',
      border: state.isFocused ? '1px solid #c4c4c4' : '1px solid #e0e0e0',
      '&:hover': { borderColor: '#c4c4c4' },
      minHeight: 38,
      alignItems: 'flex-start',
      paddingTop: 4,
      paddingBottom: 4,
    }),

    valueContainer: (base) => ({
      ...base,
      maxHeight: 80,
      overflowY: 'auto',
      paddingTop: 2,
      paddingBottom: 2,
    }),

    input: (base) => ({
      ...base,
      margin: 0,
      padding: 0,
    }),

    multiValue: (base) => ({
      ...base,
      backgroundColor: '#f5f5f5',
      borderRadius: '5px',
      paddingTop: '1px',
      paddingBottom: '1px',
      paddingRight: '8px',
    }),
    multiValueLabel: (base) => ({
      ...base,
      color: '#000',
      padding: '0 8px',
      maxWidth: 100,
      overflow: 'hidden',
      whiteSpace: 'nowrap',
      textOverflow: 'ellipsis',
      display: 'block',
    }),

    multiValueRemove: (base) => ({
      ...base,
      color: '#333333',
      backgroundColor: 'transparent',
      width: '18px',
      height: '18px',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      border: '1px solid #333333',
      borderRadius: '50%',
      '&:hover': {
        backgroundColor: 'transparent',
        border: '1px solid red',
      },
    }),
  };
  
  export const midMultiSelectStyles = {
    control: (baseStyles) => ({
      ...baseStyles,
      borderRadius: '10px',
      boxShadow: 'none',
      border: '1px solid #e0e0e0',
      height: '2.5rem',
      '&:hover': {
        borderColor: '#c4c4c4',
      },
    }),
    multiValue: (baseStyles) => ({
      ...baseStyles,
      backgroundColor: '#f5f5f5',
      borderRadius: '5px',
      paddingTop: '2px',
      paddingBottom: '2px',
      paddingRight: '8px',
    }),
    multiValueLabel: (baseStyles) => ({
      ...baseStyles,
      color: '#000',
      padding: '0 10px',
    }),
    multiValueRemove: (baseStyles) => ({
      ...baseStyles,
      color: '#333333',
      backgroundColor: 'transparent',
      width: '20px',
      height: '20px',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      border: '2px solid #333333',
      borderRadius: '50%',
      '&:hover': {
        backgroundColor: 'transparent',
        border: '2px solid red',
      },
    }),
  };
  
  export const comparisonOptions = [
    { value: '1', label: '1 week' },
    { value: '2', label: '2 weeks' },
    { value: '3', label: '3 weeks' },
  ];